
<script>
import axios from 'axios';
export default {
    data() {
        return {
            waitlistModal: false,
            form: {
                name: null,
                email: null,
                role: {
                    id: null,
                    name: null
                },
                learns: [],
            },
            errors: {},
            roles: [
                {
                    id: 'f186bf95-89d6-4469-811b-2a626fe176c3',
                    name: 'Business Owner',
                },
                {
                    id: 'eb78ad15-6162-4fb5-a120-c35d554d6c62',
                    name: 'Director',
                },
                {
                    id: 'e742854d-3f28-48a5-bb61-4a7d421230ac',
                    name: 'Manager',
                },
                {
                    id: '7e6d79d7-41e9-4ab4-a605-3d5e31bde37b',
                    name: 'Consultant/Advisor',
                },
                {
                    id: '2cec522b-5b26-4cf7-afb8-e2e5c15427e9',
                    name: 'Team Member',
                },
                {
                    id: '1b9a4020-48f3-4f72-a782-230bb0828dc1',
                    name: 'Freelancer',
                },
                {
                    id: '8661fb32-fd0b-41b9-af08-a7194889f8d6',
                    name: 'Student',
                },
                {
                    id: '9138b17c-2674-4a20-909f-057bf7c38824',
                    name: 'Other',
                }
            ],
            learns: [
                {
                    id: 'db3c1c22-f384-4bc7-8a6f-2a49521e8c7b',
                    name: 'Business & Operations',
                },
                {
                    id: '35a3b562-feba-44e4-b261-1ca478aa7205',
                    name: 'Marketing & Growth',
                },
                {
                    id: '4bcf662f-5724-4edd-bde1-f30d9323ebd3',
                    name: 'Product Management',
                },
                {
                    id: '1af72d56-4dca-467f-acb9-b3a79d5bbf74',
                    name: 'Sales & CRM',
                },
                {
                    id: '6becea8a-5245-401d-9397-b31f9d32e709',
                    name: 'Human Resources',
                },
                {
                    id: '50192af4-3bc8-4b8e-b66a-89d99ccea49d',
                    name: 'Customer Support Management',
                },
                {
                    id: '7f33b61e-ccf3-49bb-a71c-171dd2c4b738',
                    name: 'Client Project Management',
                },
                {
                    id: 'ed1e1692-a129-494b-acc6-d2dcf93c7615',
                    name: 'Information Technology (IT)',
                }
            ],
            submited: false,
            tooMany: null
        };
    },
    methods: {
        handleMultipleLearn(learn) {
            if(this.form.learns.find(addedlearn => addedlearn == learn)) {
                this.form.learns.splice(this.form.learns.findIndex(v => v.name === learn.name), 1);
            } else {
                this.form.learns.push(learn);
            }
        },
        submit() {
            this.errors = {};
            this.tooMany = null;
            if (this.form.name == null) {
                this.errors.name = 'Name is required';
            }
            if (this.form.email == null) {
                this.errors.email = 'Email is required';
            }
            if (this.form.role.id == null) {
                this.errors.role = 'Role is required';
            }
            if(this.form.learns.length == 0) {
                this.errors.learn = 'This field is required';
            }
            if (Object.keys(this.errors).length === 0) {
                this.submited = true;
                axios.post('/waitlist-form', this.form)
                    .then(() => {
                        // Perform the Intercom setup
                        return new Promise(resolve => {
                            window.Intercom('boot', {
                                app_id: 'ujmidnoy',
                                email: this.form.email,
                                name: this.form.name,
                                waitlist_submitted: true, // custom attribute (property)
                                created_at: Math.round(new Date().getTime() / 1000),
                            });
                            resolve();
                        });
                    })
                    .then(() => {
                        // Push tag to Google Tag Manager
                        dataLayer.push({ event: 'waitlist_submitted' });

                        // Send analytics
                        // return axios.put('/api/analytics', {
                        //     name: 'waitlist_submitted',
                        // });
                    })
                    .then(() => {
                        // Set cookies
                        this.$cookies.set('waitlist_submitted', true, 60 * 60 * 24 * 30 * 12);
                        this.$cookies.set('email', this.email, 60 * 60 * 24 * 30 * 12);
                        this.$cookies.set('name', this.name, 60 * 60 * 24 * 30 * 12);
                        this.submitted = true;

                        // Redirect to the thank-you page
                        window.open('/360-business-architect-thank-you', '_blank');
                        this.waitlistModal = false;
                    })
                    .catch(error => {
                        if (error.response.status === 429) {
                            this.tooMany = error.response.data.message;
                        }
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors || {};
                        }
                    });

            }
        },
    },
};
</script>

<style scoped lang="less">
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    background-color: #222;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.dropdown {
    .dropdownButton {
        // appearance: none;
        width: 100%;
        min-height: 50px;
        border: 1px solid #adadad;
        background-color: #222;
        border-radius: 6px;
        color: #fff;
        padding: 15px 12px;
        font-size: 16px;
        background-image: url('/img/pricing/dropdown-arrow-down-white.svg');
        background-repeat: no-repeat;
        background-size: 15px 9px;
        background-position: right 10px bottom 50%;
        text-align: left;
        display: flex;
        align-items: center;
        line-height: 1;
        &:focus,
        &:active {
            border: 1px solid #BFB6FF;
            outline: none;
        }
    }

    .dropdown-menu {
        width: 100%;
        background: #222;
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        padding: 7px;
        height: 200px;
        max-height: 90vh;
        overflow-y: scroll;
        color: #fff;
        &::-webkit-scrollbar {
            border-radius: 10px;
            width: 8px;
            background-color: #353535;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #505050;
        }

        .dropdown-item {
            cursor: pointer;
            border-radius: 6px;
            font-size: 16px;
            color: #fff;

            &:hover {
                background-color: #2c2c2c;
            }
        }

        .dropdown-item.active {
            background-color: transparent;
            color: #5946CF;
            background-image: url('/img/pricing/ic-check.svg');
            background-repeat: no-repeat;
            background-size: 15px 9px;
            background-position: right 10px bottom 50%;
            text-align: left;
        }
    }
}

form {
    margin: 0 auto;
    border-radius: 20px;
    background-color: #FEFEFE;
    max-height: 95vh;
    width: 890px;
    max-width: 100%;
    box-shadow: 0px 0px 15px rgba(89, 70, 207, 0.75);
    @media(max-width: 768px) {
        overflow: auto;
    }
}

.form-body {
    padding: 40px 40px;

    @media(max-width: 768px) {
        padding: 30px 10px;
    }
}

.form-body h3 {
    font-size: 34px !important;
    line-height: 48px;
}

.form-body p {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #fff;
}


.form-control::placeholder {
    color: #989898;
}

input[type="text"],
input[type="email"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-height: 50px;
    outline: none;
    color: #fff;
    &:focus,
    &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}

.form-control {
    border: 1px solid #adadad;
    background: #222;
    font-size: 16px;
    line-height: 19px;

    &:focus {
        box-shadow: unset;
    }
}

.form-group {
    margin-bottom: 30px;
    outline: none;
}

.form-group:focus {
    outline: none;

}

.send-btn {
    cursor: pointer;
    border: none;
    min-height: 50px;
}

.send-btn:active {
    outline: none;
}

.send-btn:focus {
    outline: none;
}

.multiple-item {
    background-color: #353535;
}
</style>






// WEBPACK FOOTER //
// resources/js/frontend/components/AcademyWaitlistForm.vue